import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { colors } from 'app/theme/colors'
import { breakpoint, space } from 'app/theme/tokens'

import { MOBILE_PRIMARY_PATHS } from './MobileBottomNav'

/**
 * Non-blocking notice shown at the top of a mobile page when the current
 * route isn't one of the four primary mobile surfaces (attendance, parent
 * dashboard, inventory booking, visitor entry). The page still renders below
 * in its desktop layout — this is just a hint, not a wall.
 *
 * Dismissals are stored per-path in localStorage so a power user who's
 * deliberately using a non-priority page on their phone isn't nagged on
 * every visit.
 */

const DISMISS_KEY = 'alfred:mobile-banner-dismissed'

const Banner = styled.aside`
  display: none;

  /* Only show on mobile. */
  ${breakpoint.down('tablet')} {
    display: flex;
    align-items: flex-start;
    gap: ${space.sm};
    padding: ${space.sm} ${space.md};
    margin: ${space.md} ${space.md} 0 ${space.md};
    background: ${colors.ohLightCream};
    border: 1px solid ${colors.ohYellow};
    border-radius: 8px;
    font-size: 13px;
    line-height: 1.4;
    color: ${colors.textPrimary};
  }
`

const Message = styled.div`
  flex: 1 1 auto;

  strong {
    display: block;
    margin-bottom: 2px;
    font-weight: 600;
  }
`

const readDismissed = () => {
  try {
    return JSON.parse(localStorage.getItem(DISMISS_KEY) || '{}')
  } catch {
    return {}
  }
}

const writeDismissed = (next) => {
  try {
    localStorage.setItem(DISMISS_KEY, JSON.stringify(next))
  } catch {
    /* localStorage unavailable (private mode etc.) — fail silently */
  }
}

const MobileBetterOnDesktop = () => {
  const { pathname } = useLocation()
  const [dismissed, setDismissed] = React.useState(readDismissed)

  const isPriority =
    MOBILE_PRIMARY_PATHS.has(pathname) ||
    Array.from(MOBILE_PRIMARY_PATHS).some((p) => pathname.startsWith(p + '/'))

  if (isPriority) return null
  if (dismissed[pathname]) return null

  const handleDismiss = () => {
    const next = { ...dismissed, [pathname]: true }
    setDismissed(next)
    writeDismissed(next)
  }

  return (
    <Banner role="status" aria-label="Page best viewed on desktop">
      <Message>
        <strong>this page is built for desktop</strong>
        some controls and tables may be hard to use on a phone. tap the
        hamburger or bottom nav to switch to mark-attendance, parent
        dashboard, the maintenance checklist, or visitor entry — those are
        mobile-ready.
      </Message>
      <IconButton
        size="small"
        aria-label="dismiss"
        onClick={handleDismiss}
        style={{ marginLeft: 'auto' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Banner>
  )
}

export default MobileBetterOnDesktop
